import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import LoadingProps from "./util/LoadingProvider";
const spacing = [0, 4, 8, 20, 40, 64];

const theme = createMuiTheme({
  spacing,
  palette: {
    primary: {
      light: "#333333",
      main: "#000000",
      dark: "#000000",
      contrastText: "#BCBCBC",
      contrastTextLight: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "#E5E5E5",
        },
      },
    },
    MuiFormControl: {
      marginDense: {
        margin: `${spacing[1]}px !important`,
        paddingRight: spacing[1],
        minWidth: 120,
      },
    },
    MuiButton: {
      root: {
        margin: spacing[1],
        textTransform: "capitalize",
      },
      outlinedPrimary: {
        borderColor: "#306F9D",
        color: "#306F9D",
        "&:hover": {
          borderColor: "#306F9D",
        },
      },
      containedPrimary: {
        backgroundColor: "#306F9D",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#306F9D",
        },
      },
    },
    MuiSelect: {
      root: {
        background: "#ffffff",
      },
    },
    MuiInputBase: {
      root: {
        background: "#ffffff",
      },
    },
    MuiTextField: {
      root: {
        margin: spacing[1],
        minWidth: 120,
        "& label": {
          color: "#cccccc",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "& fieldset": {
          border: "1px solid #CCCCCC",
        },
        "& input": {
          fontSize: "13px",
        },
      },
    },
    MuiInputLabel: {
      outlined: {
        fontSize: "13px",
      },
    },
    MuiFormHelperText: {
      root: {
        color: "#bcbcbc",
        marginTop: "0",
      },
      contained: {
        marginLeft: "0",
        marginBottom: "12px",
      },
    },
    MuiTab: {
      root: {
        textTransform: "capitalize",
        "&.Mui-selected": {
          background: "white",
        },
      },
    },
    MuiTable: {
      root: {
        minWidth: 650,
        backgroundColor: "white",
      },
    },
    MuiTableRow: {
      root: {
        color: "#306F9D !important",
        backgroundColor: "white",
      },
    },
    MuiTypography: {
      gutterBottom: {
        marginBottom: "1.2em",
      },
      h4: {
        fontSize: "1.65rem",
      },
      h6: {
        fontSize: "1rem",
        fontWeight: "700",
      },
    },
    MuiChip: {
      root: {
        height: "initial",
      },
    },
    MuiToggleButton: {
      root: {
        width: "100%",
        color: "#306F9D",
        textTransform: "capitalize",
        border: "1px solid #306F9D",
        lineHeight: "1",
        "&$selected": {
          backgroundColor: "#306F9D",
          color: "white",
          "&:hover": {
            backgroundColor: "#306F9D",
            color: "white",
          },
        },
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        "&$checked": {
          color: "#306F9D",
        },
      },
    },
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: "#A5CBE7",
      },
      barColorPrimary: {
        backgroundColor: "#1E8BDA",
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "rgba(159, 163, 168, 0.5)",
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: "#BCBCBC",
      },
      toolbarBtnSelected: {
        color: "white"
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#306F9D",
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: "#306F9D !important",
        color: "white",
        "& .MuiTab-root.Mui-selected": {
          backgroundColor: "#306F9D !important",
        },
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
          <LoadingProps>
            <App />
          </LoadingProps>
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
